import { isError } from "../utils/type.js";

function serializeJson(data) {
  try {
    const jsonString = JSON.stringify(data);
    return new TextEncoder().encode(jsonString);
  } catch (e) {
    if (isError(e)) {
      e.message = `JsonFeed: ${e.message}`;
    }

    throw e;
  }
}

export async function getJsonData(bee, reader) {
  const feedUpdate = await reader.download();
  const retrievedData = await bee.downloadData(feedUpdate.reference);
  return retrievedData.json();
}
export async function setJsonData(bee, writer, postageBatchId, data, options) {
  const serializedData = serializeJson(data);
  const {
    reference
  } = await bee.uploadData(postageBatchId, serializedData, options);
  return writer.upload(postageBatchId, reference);
}